import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { savePreference } from '../../../actions/displayPreferenceActions';
import { addAndApplyFilter, removeAndApplyFilter } from '../../../actions/filterActions';
import { getFilterValues, hasFilterApplied } from '../sbSharedRefineMenuHelpers';

import styles from './SbSharedRefineMenuSaleInput.scss';

import get from 'lodash.get';

// components
import { SbSharedRefineMenuInputCheckbox } from '../../SbSharedRefineMenu/SbSharedRefineMenuInput/SbSharedRefineMenuInputCheckbox';

// Constants
import { SALE } from '../../SbSharedRefineMenu/sbSharedRefineMenuConstants';

const messages = defineMessages({
    title: {
        id: 'sb.SbMobileRefineMenuFilterSale.title',
        defaultMessage: 'On sale',
    },
});

const SbSharedRefineMenuSaleInputComponent = ({ itemSearch, onSelect, onDeselect, intl }) => {
    const filters = get(itemSearch, 'filters') || [];
    const saleFilterValues = getFilterValues(filters, SALE);
    const appliedFilters = get(itemSearch, 'appliedFilters') || [];
    const isSaleFilterApplied = hasFilterApplied(appliedFilters, [SALE]);

    return saleFilterValues.map(filter => {
        const count = get(filter, 'count');
        return (
            <SbSharedRefineMenuInputCheckbox
                key={filter.urlLabel}
                value={filter.urlLabel}
                linkReference={filter.linkReference}
                linkable={filter.linkable}
                checked={isSaleFilterApplied}
                onChange={checked => {
                    if (checked) {
                        onSelect(SALE, filter);
                    } else {
                        onDeselect(SALE, filter);
                    }
                }}
                text={intl.formatMessage(messages.title)}
                className={styles.wrapper}
                count={count}
            />
        );
    });
};

SbSharedRefineMenuSaleInputComponent.propTypes = {
    intl: intlShape,
    itemSearch: PropTypes.shape({
        appliedFilters: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                values: PropTypes.arrayOf(
                    PropTypes.shape({
                        urlLabel: PropTypes.string.isRequired,
                    })
                ).isRequired,
            })
        ).isRequired,
        filters: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                values: PropTypes.arrayOf(
                    PropTypes.shape({
                        displayName: PropTypes.string.isRequired,
                        urlLabel: PropTypes.string.isRequired,
                        linkReference: PropTypes.string.isRequired,
                        linkable: PropTypes.bool.isRequired,
                        count: PropTypes.number,
                    })
                ).isRequired,
            })
        ).isRequired,
    }),
    onSelect: PropTypes.func.isRequired,
    onDeselect: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
    return {
        onSelect(name, changedPreference) {
            dispatch(savePreference(name, changedPreference));
            dispatch(addAndApplyFilter(name, changedPreference));
        },
        onDeselect(name, changedPreference) {
            dispatch(savePreference(name));
            dispatch(removeAndApplyFilter(name, changedPreference));
        },
    };
}

export const SbSharedRefineMenuSaleInput = createFragmentContainer(
    injectIntl(
        connect(
            null,
            mapDispatchToProps
        )(SbSharedRefineMenuSaleInputComponent)
    ),
    {
        itemSearch: graphql`
            fragment SbSharedRefineMenuSaleInput_itemSearch on ItemSearchQueryConnection {
                appliedFilters {
                    name
                    values {
                        urlLabel
                    }
                }
                filters {
                    name
                    values {
                        linkReference
                        linkable
                        displayName
                        urlLabel
                        count
                    }
                }
            }
        `,
    }
);
